export default "__VITE_ASSET__DV_lZXdq__"